export * from './object.mjs';
